import { apiFetch } from "./apiFetch";
import { isStandaloneMode } from "./pwaInstallPrompt";

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || "";

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeForPush(
  source: "web" | "pwa" = "web",
  opts?: { forceResubscribe?: boolean }
) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    return;
  }
  if (!VAPID_PUBLIC_KEY) {
    console.warn("REACT_APP_VAPID_PUBLIC_KEY is not set, skip push subscription");
    return;
  }

  const resolvedSource: "web" | "pwa" =
    source === "pwa" || isStandaloneMode() ? "pwa" : "web";

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return;

  const registration = await navigator.serviceWorker.ready;
  let existing = await registration.pushManager.getSubscription();
  if (existing && opts?.forceResubscribe) {
    try {
      await existing.unsubscribe();
    } catch {
      // ignore; fallback to re-subscribe attempt
    }
    existing = null;
  }

  if (existing) {
    // Уже подписаны – отправим на сервер, чтобы обновить данные userAgent/ip/source
    await apiFetch("/api/push/subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json;charset=utf-8" },
      body: JSON.stringify({
        endpoint: existing.endpoint,
        keys: existing.toJSON().keys,
        source: resolvedSource,
      }),
    });
    return;
  }

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
  });

  const json = subscription.toJSON();

  await apiFetch("/api/push/subscribe", {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=utf-8" },
    body: JSON.stringify({
      endpoint: subscription.endpoint,
      keys: json.keys,
      source: resolvedSource,
    }),
  });
}

